import { useEffect, useState } from "react";
import dataService from "../../../helpers/dataService";
import useStore from "../../../context/useStore";

const useCanEnrollEp = () => {
  const [state] = useStore();
  const role = state.auth?.user?.role;
  const [canEnroll, setCanEnroll] = useState(role !== "AGENT_PARTNER");
  const [isChecking, setIsChecking] = useState(role === "MANAGER_PARTNER");

  useEffect(() => {
    if (role === "AGENT_PARTNER") {
      setCanEnroll(false);
      setIsChecking(false);
      return;
    }

    if (role !== "MANAGER_PARTNER") {
      setCanEnroll(true);
      setIsChecking(false);
      return;
    }

    setIsChecking(true);
    dataService.get(
      "organizations/mine",
      (orgs) => {
        const hasPE = (orgs || []).some((o) => o.slugName === "PE");
        setCanEnroll(!hasPE);
      },
      () => setCanEnroll(true),
      () => setIsChecking(false)
    );
  }, [role]);

  return { canEnroll, isChecking };
};

export default useCanEnrollEp;
